import React from 'react';
import { Link } from 'react-router-dom';
import './VacancyListBlock.css';

export default class VacancyListBlock extends React.Component{
	
	static defaultProps = {
		vacancyId: 0,
		vacancyName: 'job name',
		salary: 'salary'
	};
	
	render = () => {
		return (
			<Link className="vacancy-list-block" to={`/vacancy/${this.props.vacancyId}/overview`}>
				
				<div className={'vacancy-wrapper'}>
					<div className={'vacancy-col-flex'}>
						<div className={'vacancy-col-flex-inner'}>
							<h6 className="h6-rcg">Job Title</h6>
							<p className="user-content">
								{this.props.vacancyName}
							</p>
						</div>
					</div>
					<div className={'vacancy-col-flex'}>
						<div className={'vacancy-col-flex-inner'}>
							<h6 className="h6-rcg">Salary</h6>
							<p className="user-content">
								{this.props.salary}
							</p>
						</div>
					</div>
				</div>
				
			</Link>
		);
	};
}


// WEBPACK FOOTER //
// ./src/components/VacancyListBlock.js